import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["sectionableType", "selector", "fieldsContainer"];

  setType(event) {
    event.preventDefault();

    // Set sectionable type input value
    const sectionType = event.currentTarget.dataset.section_type;
    this.sectionableTypeTarget.value = sectionType;

    // Hide selector grid
    this.selectorTarget.classList.add("hidden");

    this.fieldsContainerTarget.querySelectorAll("[data-section-type]").forEach((container) => {
      const fieldset = container.querySelector("fieldset");
      if (container.dataset.sectionType !== sectionType) {
        // Remove unused fields from DOM
        container.remove();
      } else {
        // Display & enable used fields
        container.classList.remove("hidden");
        fieldset.disabled = false;
      }
    });
  }
}
